/** One row of the categories list. */
export interface AttritionCategoryListItem {
  id: string;
  name: string;
  description?: string | null;
  sortOrder: number;
  /** The live documents on the checklist. */
  documentCount: number;
  /** Live requests filed under it. */
  requestCount: number;

  isActive: boolean;
  createdAt: string;
  createdByName?: string | null;
  updatedAt?: string | null;
  updatedByName?: string | null;
}

/** One checklist line — the document asked for, and the account that reviews it. */
export interface AttritionCategoryDocument {
  id: string;
  name: string;
  description?: string | null;
  reviewerUserId: string;
  /** The account's display name, read LIVE. Omitted from the wire for an account that is gone. */
  reviewerName?: string | null;
  /** False when the reviewer's account is deactivated — the line then waits on nobody. */
  reviewerIsActive: boolean;
  sortOrder: number;
}

export interface AttritionCategoryDetail {
  id: string;
  name: string;
  description?: string | null;
  sortOrder: number;
  /** The live checklist, in order. */
  documents: AttritionCategoryDocument[];
  requestCount: number;

  isActive: boolean;
  createdAt: string;
  createdByName?: string | null;
  updatedAt?: string | null;
  updatedByName?: string | null;
}

/**
 * One checklist line on the wire. `id` names a line already on the checklist so the requests
 * filed against it keep pointing at it; null adds one. Every row on screen is sent, blanks
 * included, so a rejection's index is the row the reader sees.
 */
export interface AttritionCategoryDocumentInput {
  id: string | null;
  name: string;
  description: string | null;
  reviewerUserId: string | null;
}

/** Create and edit. The position and the counts are the server's. */
export interface AttritionCategoryRequest {
  name: string;
  description: string | null;
  documents: AttritionCategoryDocumentInput[];
}

/** The module's one list of what its writes touch — read by every History Logs surface. */
export const ATTRITION_CATEGORY_AUDIT_ENTITY_TYPES = ['AttritionCategory', 'AttritionCategoryDocument'];
